import { shopApi } from "../api";
import { ThunkAction } from "redux-thunk";
import { AppState, AppActions } from "../Store/store";

interface IChartsState {
  ordersChart: [],
  ordersChartStatus: 'loading' | 'loaded',
}
const chartsState: IChartsState = {
  ordersChart: [],
  ordersChartStatus: 'loading',
}

// Action types
export const SET_ORDERS_CHART = 'shop/SET_ORDERS_CHART';
export const SET_ORDERS_CHART_STATUS = 'shop/SET_ORDERS_CHART_STATUS';

// Selectors
export const ordersChartSelector = (state: any) => state.charts.ordersChart;
export const ordersChartStatusSelector = (state: any) => state.charts.orders.ordersChartStatus;


// Reducer
export function chartsReducer(state: IChartsState = chartsState, action: any) {
  switch (action.type) {
    case SET_ORDERS_CHART: {
      const data = action.payload.map((item: any) => {
        return {
          name: item.monthName,
          count: item.orders
        }
      });
      return {
        ...state,
        ordersChart: data
      }
    }

    case SET_ORDERS_CHART_STATUS: {
      return {
        ...state,
        ordersChartStatus: action.payload
      }
    }

    default: {
      return state;
    }
  }
}

// Actions
interface GetOrdersChartType {
  type: typeof SET_ORDERS_CHART,
  payload: []
}
export function getOrdersChart(): ThunkAction<Promise<void>, AppState, unknown, AppActions> {
  return async (dispatch: any, getState: any) => {
    const response = await shopApi.ordersChart();
    dispatch(setOrdersChartStatus('loading'));
    dispatch({
      type: SET_ORDERS_CHART,
      payload: response
    });
    dispatch(setOrdersChartStatus('loaded'));
  }
}

interface SetOrdersChartStatusType {
  type: typeof SET_ORDERS_CHART_STATUS,
  payload: string
}
export function setOrdersChartStatus(payload: string): SetOrdersChartStatusType {
  return {
    type: SET_ORDERS_CHART_STATUS,
    payload
  };
}

export type ChartsActions =
  SetOrdersChartStatusType
  | GetOrdersChartType;